export default {
  events: [],
  serviceRequests: []
}
